var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertChart24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.00131L6 3.00016C4.9 3.00007 3.99993 3.9 3.99984 5L3.99869 19C3.9986 20.1 4.89852 21.0001 5.99852 21.0002L19.9985 21.0013C21.0985 21.0014 21.9986 20.1015 21.9987 19.0015L21.9998 5.00148C21.9999 3.90148 21.1 3.0014 20 3.00131ZM19.9987 19.0013L5.99869 19.0002L5.99984 5.00016L19.9998 5.00131L19.9987 19.0013ZM9.99943 10.0005L7.99943 10.0003L7.99885 17.0003L9.99885 17.0005L9.99943 10.0005ZM11.9997 7.00066L13.9997 7.00082L13.9989 17.0008L11.9989 17.0007L11.9997 7.00066ZM17.9992 13.0011L15.9992 13.001L15.9989 17.001L17.9989 17.0011L17.9992 13.0011Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertChart24Px);
export default __webpack_public_path__ + "static/media/insert_chart_24px.8527e2c2aea0a6bd4fc351b71f7b83f8.svg";
export { ForwardRef as ReactComponent };